import roomsParser from './roomsParser';
import { RoomsType, RoomsDataType } from './types';

const mapRooms = (data: RoomsType): RoomsDataType => data.map(roomsParser);

export default mapRooms;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/mapRooms.ts